import React, { useState, useEffect } from 'react';
import '../styles/pages/Rules.scss';

const Rules = () => {
  const [activeServer, setActiveServer] = useState(null);

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data.uid && e.data.type === 'sizeUpdate') {
        const iframe = document.querySelector(`iframe[name="${e.data.uid}"]`);
        if (iframe) {
          iframe.style.width = e.data.payload.width;
          iframe.style.height = e.data.payload.height;
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const toggleServer = (serverId) => {
    setActiveServer(activeServer === serverId ? null : serverId);
  };

  const serverData = [
    {
      id: 'kafes',
      name: '[TR] ▦ KAFES ▦ TRY HARD | BLACKOWLS.NET | HOSTED BY SQTR',
      ip: '5.9.104.40:7793',
      bannerUrl: "https://cdn.battlemetrics.com/b/uYbnVd3nN/31759745.html?_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjUyNDYiLCJzZXJ2ZXIiOjMxNzU5NzQ1LCJvcHRpb25zIjp7ImZvcmVncm91bmQiOiIjRUVFRUVFIiwiYmFja2dyb3VuZCI6IiMyMjIyMjIiLCJsaW5lcyI6IiMzMzMzMzMiLCJsaW5rQ29sb3IiOiIjMTE4NWVjIiwiY2hhcnRDb2xvciI6IiNGRjA3MDAifSwibGl2ZVVwZGF0ZXMiOnRydWUsInVzZXJfaWQiOjYzMzY5MCwiaWF0IjoxNzQxNzE5MjI5fQ._laVsS7Q6eEMsMAkpCwECob7uM-tw2GidmWWdOS0O74",
      rulesUrl: "https://docs.google.com/document/d/e/2PACX-1vTjHH_yAUyJEJMaHeyV1b_HGQgW3ocWeTbM685GFQRPw9lVqaNvldKYisPtdFfTXxeQKzrgHdTCSlr5/pub"
    },
    // {
    //   id: 'kaos',
    //   name: '[TR] ▽ KAOS ▽ NO RULES | BLACKOWLS.NET | HOSTED BY SQTR',
    //   ip: '5.9.104.40:7794',
    //   bannerUrl: "https://cdn.battlemetrics.com/b/rW6wapJAo/31833840.html?_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjUyNDkiLCJzZXJ2ZXIiOjMxODMzODQwLCJvcHRpb25zIjp7ImZvcmVncm91bmQiOiIjRUVFRUVFIiwiYmFja2dyb3VuZCI6IiMyMjIyMjIiLCJsaW5lcyI6IiMzMzMzMzMiLCJsaW5rQ29sb3IiOiIjMTE4NWVjIiwiY2hhcnRDb2xvciI6IiNGRjA3MDAifSwibGl2ZVVwZGF0ZXMiOnRydWUsInVzZXJfaWQiOjYzMzY5MCwiaWF0IjoxNzQxODc2NDgwfQ.xHmBqWGSQFV0oGuAMP3becMiGoAo6ADV4TTzKb1--iQ",
    //   rulesUrl: "https://docs.google.com/document/d/e/2PACX-1vSaRuRerRs5mgbVwf4d9eQ7qsoffEjLj6Au4norAfW_4_MmqnJl6c_6O4EQzKYAC-isO5fvbEINhUO-/pub"
    // }
  ];

  return (
    <div className="rules-page">
      <div className="container">
        <h1 className="page-title">SUNUCU KURALLARI</h1>
        
        <div className="server-cards">
          {serverData.map((server) => (
            <div key={server.id} className="server-card-wrapper">
              <div className={`server-card ${activeServer === server.id ? 'active' : ''}`}>
                <div className="server-header">
                  <div className="server-icon"></div>
                  <div className="server-name">{server.name}</div>
                </div>
                
                <div className="banner-container">
                  <iframe 
                    src={server.bannerUrl} 
                    frameBorder="0" 
                    className="battle-metrics-iframe"
                    name={`server-${server.id}`}
                    scrolling="no"
                  />
                </div>
                

                
                <div className="expand-arrow">
                  <span 
                    className={`arrow ${activeServer === server.id ? 'up' : 'down'}`}
                    onClick={() => toggleServer(server.id)}
                  >
                    {activeServer === server.id ? 'Kuralları Gizle' : 'Kuralları Göster'} ▼ 
                  </span>
                </div>
              </div>
              
              {activeServer === server.id && (
                <div className="server-rules-content">
                  <div className="iframe-container">
                    <iframe 
                      src={server.rulesUrl} 
                      frameBorder="0"
                      className="google-docs-iframe"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rules;